import { inject, ref } from 'vue';

import EpkReportsApiService from '@/api/client/services/EpkReportsApiService';
import getFieldNameForPrintAndSign from '@/helpers/getFieldNameForPrintAndSign';
import isEmptyId from '@/helpers/isEmptyId';
import setBlobApplicationType from '@/helpers/setBlobApplicationType';
import EpkReportsPrintService from '@/utils/_print/EpkReportsPrintService';

export const usePrintService = (options: object) => {
  const printService = new EpkReportsPrintService({
    inject,
    ...options,
  });

  async function rollbackBook() {
    if (printService.pointCode) {
      const epkReportsApiService = new EpkReportsApiService();
      await epkReportsApiService.rollbackBook(printService.pointCode);
    } else {
      console.error('Не удалось откатить утверждение книги');
    }
  }

  async function getUrl(format, mode) {
    if (
      !printService.isInited ||
      isEmptyId(printService.cacheGuid) ||
      !printService.entityInstance
    ) {
      await printService.init();
    }

    const field = getFieldNameForPrintAndSign(format, mode);

    const hasLatest = field && Boolean(printService.entityInstance[field]);
    console.log(format + ' hasLatest=', hasLatest);
    // if (printService.entityInstance.req_eds && !hasLatest) {
    //   // подписан, но файла нет
    //   await rollbackBook();
    //   // т.к. задержка несколько секунд, пусть пользователь сам повторно выполнит операцию
    //   const msg =
    //     'Документ был подписан, но не имел печатной формы. Был выполнен откат подписания. Повторите операцию';
    //   console.error(msg);
    //   throw Error(msg);
    // }
    if (!hasLatest) {
      if (format === 'zip') {
        return '';
      }
      await printService.print(format, undefined, undefined, mode);
    }
    return await printService.urlNew(format, true, mode);
  }

  /* Simplified `getUrl` */
  async function fetchUrlMap(format: string, mode: string) {
    if (
      !printService.isInited ||
      isEmptyId(printService.cacheGuid) ||
      !printService.entityInstance
    ) {
      await printService.init();
    }

    const entityInstance = printService.entityInstance;

    const fieldOrFields = getFieldNameForPrintAndSign(format, mode);

    /*  */
    let hasLatest;
    if (Array.isArray(fieldOrFields)) {
      hasLatest = fieldOrFields.every(field => Boolean(entityInstance[field]));
    } else {
      hasLatest = fieldOrFields && Boolean(entityInstance[fieldOrFields]);
    }

    console.log(format + ' hasLatest=', hasLatest);

    if (hasLatest) return await printService.urlNew(format, true, mode);

    return await printService.print(format, undefined, undefined, mode, true);
  }

  const blobFetch = async (format, applicationType, mode) =>
    getUrl(format, mode)
      .then(url => {
        console.log('then url=', url);
        return url;
      })
      .then(url => printService.blobFetchFromUrl(url))
      .then(result =>
        result.status
          ? setBlobApplicationType(result.data, applicationType)
          : undefined
      );

  const blobFetchFromUrl = async (url: string) =>
    printService.blobFetchFromUrl(url);
  // const blobFetchTest = async (ntDownload = true) => {
  //   const url = await getUrl();
  //   console.log('blobFetchTest url>', url, printService);

  //   let blob;
  //   const blobUrlDefault =
  //     'https://epk.mkskom.ru/minio_download/testclientapp-orchestra-svodforprint/ed439e91418857b5e5586c727474b058';
  //   try {
  //     const result = await printService.blobFetchFromUrl(url || blobUrlDefault);
  //     if (result.status) {
  //       blob = setBlobApplicationType(result.data); // rewrite type
  //       console.log(28, { blob, ntDownload });
  //       if (ntDownload) {
  //         await download(blob, 'file.pdf', undefined, false);
  //       }
  //     }
  //   } catch (err) {
  //     console.warn('ERROR!', err instanceof Error ? err.message : err);
  //   }
  //   return blob;
  // };

  /* State */
  const btnStopped = ref(false);

  /* Helpers */
  const withProgress = async (fn: () => boolean | Promise<boolean>) => {
    btnStopped.value = false;
    const result = await fn();
    btnStopped.value = true;
    return result;
  };

  /* Handlers */
  // const onBtnClick = async () => {
  //   withProgress(async () => {
  //     const formats = [
  //       {
  //         format: 'pdf',
  //         applicationType: mime.pdf,
  //         filename: 'file.pdf',
  //       },
  //       {
  //         format: 'xlsx',
  //         applicationType: mime.xlsx,
  //         filename: 'file.xlsx',
  //       },
  //     ];
  //     for (const { format, applicationType, filename } of formats) {
  //       blobFetch(format, applicationType).then(blob =>
  //         download(blob, filename, applicationType, false)
  //       );
  //     }
  //   });
  // };
  const onBtnEnd = () => console.log('onBtnEnd');

  return {
    withProgress,
    fetchUrlMap,
    blobFetch,
    blobFetchFromUrl,
    // blobFetchTest,
    btnStopped,
    // onBtnClick,
    onBtnEnd,
    rollbackBook,
    printService,
  };
};
